import React, { useState } from "react";
import RegistrationCheck from "./RegistrationCheck";
import AssessmentResult from "./AssessmentResult";
import { get } from "../../services/api";

function AdmissionMultistepForm() {
  const [currentStep, setCurrentStep] = useState(1);
  const [fetchedCenterId, setFetchedCenterId] = useState(null);
  const [fetchedClassId, setFetchedClassId] = useState(null);
  const [regNo, setRegNo] = useState("");

  const goToNextStep = (centerId, classId, regNo) => {
    setFetchedCenterId(centerId);
    setFetchedClassId(classId);
    setRegNo(regNo);
    setCurrentStep(2);
  };

  return (
    <div>
      <div className="page-header d-flex mb-2">
        <h2 className="page-heading fs-7">New Admission</h2>
      </div>

      {currentStep === 1 && (
        <RegistrationCheck onRegistrationSubmit={goToNextStep} />
      )}

      {currentStep === 2 && fetchedCenterId && fetchedClassId && (
        <AssessmentResult
          centerId={fetchedCenterId}
          classId={fetchedClassId}
          regNo={regNo}
        />
      )}
    </div>
  );
}

export default AdmissionMultistepForm;
